import React, { useEffect } from "react";
import { setIdentifierShop } from "@pages/Applications/DeviceAssociateModal/store";
import { logger } from "@helpers/logger";

const DEFAULT_ADYEN_CONFIG = {
    merchantAccount: "",
    cryptoVersion: "",
    keyIdentifier: "",
    passphrase: "",
    keyVersion: "",
    communication: "Local",
    WebhookConfig: "",
    currency: "",
    merchantTicket: false,
    customerTicket: true,
    apiKey: "",
    userName: "",
    userPassword: "",
    shopIdentifier: "",
    isAutoFill: false,
};

type UseAdyenConfigProps = {
    mark: string;
    editedData: any;
    oneShop: boolean;
    shopID: string;
    franchiseID: string;
    selectedRows: any;
    shopIds: any;
    tableData: any;
    isEdited: boolean;
    isModalAssociate?: boolean;
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>;
    isCurrencyExistInShop: (shopId: string) => Promise<string>;
    setIpAddress: (v: string) => void;
    setPort: (v: any) => void;
    setWebhook: (v: string) => void;
    setCurrency: (v: string) => void;
};

export function useAdyenConfig({
    mark,
    editedData,
    oneShop,
    shopID,
    franchiseID,
    selectedRows,
    shopIds,
    tableData,
    isEdited,
    isModalAssociate,
    fetchGlobal,
    isCurrencyExistInShop,
    setIpAddress,
    setPort,
    setWebhook,
    setCurrency,
}: UseAdyenConfigProps) {
    const defaultAdyenConfig =
        oneShop && tableData?.othersData?.adyenConfig !== undefined
            ? tableData?.othersData?.adyenConfig
            : selectedRows[0]?.adyenConfig !== undefined &&
              Object.keys(selectedRows[0]?.adyenConfig).length > 0
            ? selectedRows[0].adyenConfig
            : DEFAULT_ADYEN_CONFIG;

    const [adyenConfig, setAdyenConfig] = React.useState(
        editedData.Id === undefined
            ? defaultAdyenConfig
            : editedData?.adyenConfig
    );

    const [isAutoFill, setIsAutoFill] = React.useState(
        adyenConfig.isAutoFill ?? false
    );
    // eslint-disable-next-line
    const [adyenIpExist, setAdyenIpExist] = React.useState<
        boolean | undefined
    >(false);
    const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
    const [IDAdyen, setIDAdyen] = React.useState([]);
    const [isIdExist, setIsIdExist] = React.useState(false);
    const [selectedIdAdyen, setSelectedIdAdyen] = React.useState({
        label: "",
        value: "",
    });
    const [isShopHasAdyen, setIsShopHasAdyen] = React.useState<boolean>(false);
    const [merchantAccountId, setMerchantAccountId] =
        React.useState<string>("");

    const fetchAdyenInfo = async (shopId: string) => {
        setIsDisabled(true);
        try {
            const localDefaultAdyenConfig =
                editedData?.adyenConfig !== undefined
                    ? editedData?.adyenConfig
                    : oneShop &&
                      tableData?.othersData?.adyenConfig !== undefined
                    ? tableData?.othersData?.adyenConfig
                    : selectedRows[0]?.adyenConfig !== undefined &&
                      Object.keys(selectedRows[0]?.adyenConfig).length > 0
                    ? selectedRows[0].adyenConfig
                    : DEFAULT_ADYEN_CONFIG;
            const api = `${process.env.REACT_APP_ACCESS_API_URL}/getAdyenInfo?uidentitie=${shopId}`;

            const data = await fetchGlobal<any>(api, {
                headers: { "Content-Type": "application/json" },
                method: "GET",
            });
            let currencyExist: any = await isCurrencyExistInShop(shopId);
            setCurrency(currencyExist);
            if (data.data === null || data.data === undefined) {
                setAdyenConfig({ ...adyenConfig, currency: currencyExist });
            } else if (data.data.idMarchandPos !== undefined) {
                setIsShopHasAdyen(true);
                if (isAutoFill) setMerchantAccountId(data.data.idMarchandPos);
                setIdentifierShop(data.data.referenceShop);
                setAdyenConfig({
                    ...adyenConfig,
                    currency: currencyExist,
                    merchantAccount: isAutoFill
                        ? data.data.idMarchandPos
                        : merchantAccountId,
                    shopIdentifier: isAutoFill
                        ? data.data.referenceShop
                        : adyenConfig.shopIdentifier,
                });
            }
            if (
                data.data !== null &&
                data.error === false &&
                data.data.idMarchandPos !== undefined &&
                data.data.referenceShop !== undefined
            ) {
                const apiUrl = `${process.env.REACT_APP_ACCESS_API_URL}/getShopTerminalsList?merchantaccount=${data.data.idMarchandPos}&storeId=${data.data.storeIdPos}`;
                const dataUrl = await fetchGlobal<any>(apiUrl, {
                    headers: { "Content-Type": "application/json" },
                    method: "GET",
                });

                if (dataUrl.length > 0) {
                    const isaddedItem =
                        editedData.Id === undefined ? true : false;
                    const apiUrlUpdate = `${
                        process.env.REACT_APP_API_V2_URL
                    }/settings/list-adyen-no-used?shopId=${shopId}&franchiseId=${franchiseID}&isaddedItem=${isaddedItem}&adyenIDs=${dataUrl}&id=${
                        isaddedItem ? "" : editedData.adyenIp
                    }`;
                    const dataNewListe = await fetchGlobal<any>(apiUrlUpdate, {
                        headers: { "Content-Type": "application/json" },
                        method: "GET",
                    });

                    setIDAdyen(dataNewListe.difference);
                    if (dataNewListe.difference.length > 0) {
                        const options = dataNewListe.difference.map(
                            (item: any) => ({
                                label: item,
                                value: item,
                            })
                        );
                        if (
                            (!isEdited &&
                                editedData?.adyenConfig?.isAutoFill) ||
                            (isEdited && isAutoFill)
                        ) {
                            if (
                                selectedIdAdyen.label !== "" &&
                                options.every(
                                    (el: any) =>
                                        el.label !== selectedIdAdyen.label
                                )
                            ) {
                                setSelectedIdAdyen({ label: "", value: "" });
                                setIpAddress("");
                                setPort("");
                                setWebhook("");
                                setTimeout(() => {
                                    setIsDisabled(false);
                                }, 3000);
                            } else {
                                if (
                                    isEdited === false &&
                                    editedData.Id !== undefined
                                ) {
                                    setSelectedIdAdyen({
                                        value: editedData.adyenIp,
                                        label: editedData.adyenIp,
                                    });
                                    setIpAddress(editedData.ip);
                                    setPort(editedData.port);
                                    setWebhook(editedData.webhook);
                                    setIsDisabled(false);
                                } else {
                                    setIsDisabled(false);
                                }
                            }
                        } else {
                            setIsDisabled(false);
                        }
                    } else if (dataNewListe.difference.length === 0) {
                        if (isAutoFill) {
                            setSelectedIdAdyen({ label: "", value: "" });
                        }
                        setAdyenConfig(localDefaultAdyenConfig);
                        setIsDisabled(false);
                    }
                } else {
                    setAdyenConfig(localDefaultAdyenConfig);
                    setIsDisabled(false);
                }
            } else {
                setIsDisabled(false);
            }
        } catch (error) {
            logger.error("Error fetching Adyen data:", error);
        }
    };

    useEffect(() => {
        if (editedData.Id !== undefined) {
            setAdyenConfig(editedData.adyenConfig);
        } else {
            setAdyenConfig(defaultAdyenConfig);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedData, oneShop, selectedRows, tableData, isModalAssociate]);

    React.useEffect(() => {
        if (mark === "Adyen") {
            let shopId = oneShop
                ? shopID
                : selectedRows.length > 0
                ? selectedRows[0].shopId
                : editedData.shopId;
            fetchAdyenInfo(shopId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mark, selectedRows, shopIds, editedData, isAutoFill]);

    React.useEffect(() => {
        setAdyenConfig({ ...adyenConfig, isAutoFill: isAutoFill });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAutoFill]);

    return {
        defaultAdyenConfig,
        adyenConfig,
        setAdyenConfig,
        isAutoFill,
        setIsAutoFill,
        IDAdyen,
        selectedIdAdyen,
        setSelectedIdAdyen,
        isShopHasAdyen,
        merchantAccountId,
        setMerchantAccountId,
        isIdExist,
        setIsIdExist,
        isDisabled,
        setIsDisabled,
        adyenIpExist,
        setAdyenIpExist,
    };
}
